import FLAG_ML from "../Assets/flags/ML.png";
import FLAG_CI from "../Assets/flags/CI.png";
import FLAG_SN from "../Assets/flags/SN.png";
import FLAG_BF from "../Assets/flags/BF.png";
import FLAG_BN from '../Assets/flags/BENIN.png';
import FLAG_RDC from '../Assets/flags/CONCO RDC.png';
import FLAG_CBRA from "../Assets/flags/CONGO BRAZZA.png";
import FLAG_GE from '../Assets/flags/GUINÉE.png';
import FLAG_NR from "../Assets/flags/NIGER.png";
import FLAG_TG from "../Assets/flags/TOGO.png";
import FLAG_CN from "../Assets/flags/CAMEROON.png";



export const countrylist = [
  {
    name: "Mali",
    code: "ml",
    dialCode: "223",
    flag: FLAG_ML,
  },
  {
    name: "Côte d’Ivoire",
    code: "ci",
    dialCode: "225",
    flag: FLAG_CI,
  },
  {
    name: "Bénin",
    code: "bj",
    dialCode: "229",
    flag: FLAG_BN,
  },
  {
    name: "Sénégal",
    code: "sn",
    dialCode: "221",
    flag: FLAG_SN,
  },
  {
    name: "Burkina Faso",
    code: "bf",
    dialCode: "226",
    flag: FLAG_BF,
  },
  {
    name: "Cameroun",
    code: "cm",
    dialCode: "237",
    flag: FLAG_CN,
  },
  {
    name: "Congo (DRC)",
    code: "cd",
    dialCode: "243",
    flag: FLAG_RDC,
  },
  {
    name: "Congo Brazzaville",
    code: "cg",
    dialCode: "242",
    flag: FLAG_CBRA,
  },
  {
    name: "Guinée Conakry",
    code: "gn",
    dialCode: "224",
    flag: FLAG_GE,
  },
  {
    name: "Niger",
    code: "ne",
    dialCode: "227",
    flag: FLAG_NR,
  },
  {
    name: "Togo",
    code: "tg",
    dialCode: "228",
    flag: FLAG_TG,
  },
];
